module.exports = "/packs/media/images/icons/socsec-75a732bdaee993e4543834275abbfc09.png";